const CLASS_ACCORDION = '.haas-accordion';

let accordionItems: Array <HTMLDetailsElement>;
let obj: HaasAccordion;
export default class HaasAccordion {

    constructor() {
        accordionItems = Array.from(document.querySelectorAll(CLASS_ACCORDION));
        obj = this;
        if(accordionItems.length > 0) {
            this.run();
        }
    }

    run() {
        accordionItems.forEach((item) => {
            item.addEventListener("click", function() {
                obj.closeAll(item);
            });
        });
    }

    closeAll(target: HTMLDetailsElement) {
        accordionItems.forEach((item) => {
            if(target != item) {
                item.open = false;
            }
        });
    }

}